import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-hot-toast";
import { useRecoilValue } from "recoil";
import { Input, Modal, ModalBody } from "reactstrap";
import { cleanRut, formatRut } from "rutlib/lib";
import PropTypes from "prop-types";

import { useCollaboratorsActions } from "../../../../services/actions/collaborators.actions";
import { crudCollaboratorsAtom } from "../../../../services/atoms/collaborators.atoms";
import {
  newValidatePhone,
  validRut,
  validateEmail,
  validatePhone,
} from "../../../../helpers/functions";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { ButtonIcon } from "../../../../components/buttons/button-icon";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { useChargesAction } from "../../../../services/actions/charges.action";

const today = new Date().toISOString().split("T")[0];

const initialDataStates = {
  rut: "",
  email: "",
  phone: "",
};

const CreateCollaboratorModal = (props) => {
  const {
    open,
    toggle,
    clientId,
    update,
    handleOpenModal,
    bulkLoad,
    charge,
    setRutNewCollab,
  } = props;
  const { createCollaborator } = useCollaboratorsActions();
  const { listCharges } = useChargesAction();
  const collaboratorResolver = useRecoilValue(crudCollaboratorsAtom);
  const [data, setData] = useState(initialDataStates);
  const [isInternal, setIsInternal] = useState(false);
  const [charges, setCharges] = useState([]);

  const getCharges = async () => {
    const response = await listCharges({ currentClientsId: clientId });
    setCharges(response?.data);
  };

  useEffect(() => {
    getCharges();
    //eslint-disable-next-line
  }, []);

  const handleChange = (key, value) =>
    setData((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const formdata = new FormData(e.target);
    let newData = Object.fromEntries(formdata.entries());
    const dataForSend = {
      ...newData,
      id: uuidv4(),
      clientId,
      collaboratorInternal: isInternal,
      collaboratorExternal: !isInternal,
      phone: data.phone === "" ? "" : data.phone,
      birthDate: newData.birthDate || "",
      area: newData.area || "",
      company: (newData.company || "").trim(),
      startDate: newData.startDate || "",
      // position: charge || newData.position === "Seleccionar" ? "" : newData.position || ""
      position: charge
        ? charge
        : (newData.position === "Seleccionar" ? "" : newData.position) || "",
    };
    createCollaborator(dataForSend, () => {
      toast.success("Colaborador creado exitosamente", { duration: 4000 });
      update();
      toggle();
      setRutNewCollab && setRutNewCollab(newData.rut);
    });
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Crear Colaborador</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="origenCollaborator">Origen Colaborador</label>
                  <select onChange={() => setIsInternal(!isInternal)} required>
                    <option value="externo">Externo</option>
                    <option value="interno">Interno</option>
                  </select>
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">
                    Nombre<span className="gm-span-required">*</span>
                  </label>
                  <input type="text" id="name" name="name" required />
                </div>
                <div className="gm-modal-input-group ">
                  <label htmlFor="surname">
                    Apellido<span className="gm-span-required">*</span>
                  </label>
                  <input type="text" id="surname" name="surname" required />
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group ">
                  <label htmlFor="rut">
                    RUT<span className="gm-span-required">*</span>
                  </label>
                  <Input
                    type="text"
                    id="rut"
                    name="rut"
                    onChange={(e) =>
                      handleChange("rut", cleanRut(e.target.value))
                    }
                    value={data?.rut ? formatRut(data.rut) : ""}
                    invalid={data?.rut ? !validRut(data.rut) : false}
                    maxLength={13}
                    required
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="birthDate">Fecha de nacimiento</label>
                  <input
                    type="date"
                    id="birthDate"
                    name="birthDate"
                    max={today}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group">
                  <label htmlFor="email">
                    Correo<span className="gm-span-required">*</span>
                  </label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    onChange={(e) => handleChange("email", e.target.value)}
                    maxLength={90}
                    invalid={validateEmail(data.email)}
                    required
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="phone">Teléfono</label>
                  {/* <div className="gm-number-form">
                    <div>+56</div>
                    <Input
                      type="text"
                      id="phone"
                      name="phone"
                      onChange={(e) => handleChange("phone", e.target.value)}
                      maxLength={9}
                      invalid={!validatePhone(data.phone)}
                    />
                  </div> */}
                  <Input
                    type="text"
                    id="phone"
                    name="phone"
                    onChange={(e) => handleChange("phone", e.target.value)}
                    maxLength={20}
                    invalid={!newValidatePhone(data.phone)}
                    placeholder="+569 1234 5678"
                  />
                </div>
              </div>
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="company">Empresa</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    maxLength={200}
                    placeholder="Empresa a la que pertenece"
                  />
                </div>
              </div>
              {!isInternal && !charge && (
                <div className="gm-modal-form-group">
                  <div className="gm-modal-input-group">
                    <label>Proceso de Evaluación: </label>
                    <select
                      name="position"
                      onChange={(e) => handleChange("position", e.target.value)}
                    >
                      <option value={null}>Seleccionar</option>
                      {charges?.map((charges, index) => (
                        <option key={`${charges.name}-${index}`} value={charges.name}>{charges.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {isInternal && (
                <div>
                  <div className="gm-modal-form-group-grid">
                    <div className="gm-modal-input-group ">
                      <label htmlFor="startDate">Inicio en la Empresa</label>
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        max={today}
                      />
                    </div>
                    <div className="gm-modal-input-group">
                      <label htmlFor="area">Área de trabajo</label>
                      <input type="text" id="area" name="area" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="gm-modal-buttons">
            {bulkLoad && (
              <ButtonIcon
                Icon={AiOutlineCloudUpload}
                buttonLabel="Carga Masiva"
                type="button"
                className="gm-outline-button"
                onClick={() => {
                  handleOpenModal("bulk");
                  toggle();
                }}
              />
            )}
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Crear"
              disabled={
                !validRut(data.rut) ||
                data.email === "" ||
                validateEmail(data.email) ||
                !newValidatePhone(data.phone) ||
                collaboratorResolver.loading
              }
              loading={collaboratorResolver.loading}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

CreateCollaboratorModal.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  clientId: PropTypes.string,
  update: PropTypes.func,
};

export default CreateCollaboratorModal;
